import { browser } from '$app/environment';

import { Bench } from '$lib/bench';
import { semanticVersion } from '$lib/constants';
import { clientRepo } from '$lib/states/client-repo.svelte';
import { compareSemVer } from '$lib/utils';

export async function load({ depends }) {
	Bench.mark('sveltekit.layout.load');
	const recentChats = (await clientRepo.repo?.getChatsList({ limit: 10 })) || [];
	depends('chats:recent');

	const profile = await clientRepo.repo?.getProfile();
	depends('profiles:current');

	const breadcrumbs: {
		title: string;
		url: string;
	}[] = [];

	const hasChangelogUpdates = getHasChangelogUpdates();

	return {
		breadcrumbs,
		profile,
		recentChats,
		hasChangelogUpdates
	};
}

function getHasChangelogUpdates() {
	if (!browser) {
		return false;
	}

	const lastSeenVersion = globalThis.localStorage.getItem('quill-last-seen-version');
	if (!lastSeenVersion) {
		return true;
	}

	return compareSemVer(lastSeenVersion, semanticVersion) !== 0;
}
